module.exports = __webpack_public_path__ + "media/images/cellphone-ringing-84cb9f7aff558d81b0725e5fa2c56979.png";